import localforage from '../_virtual/localforage.js';

class Storage {
  constructor(options) {
    this.storage = localforage.createInstance({
      ...Storage.DefaultOptions,
      ...options
    });
  }
  storage;
  getItem(key, callback) {
    return this.storage.getItem(key, callback);
  }
  setItem(key, value, callback) {
    return this.storage.setItem(key, value, callback);
  }
  removeItem(key, callback) {
    return this.storage.removeItem(key, callback);
  }
  clear(callback) {
    return this.storage.clear(callback);
  }
  length(callback) {
    return this.storage.length(callback);
  }
  key(keyIndex, callback) {
    return this.storage.key(keyIndex, callback);
  }
  keys(callback) {
    return this.storage.keys(callback);
  }
  iterate(iteratee, callback) {
    return this.storage.iterate(iteratee, callback);
  }
  static DefaultOptions = {
    driver: [
      localforage.WEBSQL,
      localforage.INDEXEDDB,
      localforage.LOCALSTORAGE
    ],
    version: 1e5,
    size: 4980736
  };
}

export { Storage };
//# sourceMappingURL=storage.js.map
